import { render, staticRenderFns } from "./AdminQualityReport.vue?vue&type=template&id=1727f271"
import script from "./AdminQualityReport.vue?vue&type=script&lang=js"
export * from "./AdminQualityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1727f271')) {
      api.createRecord('1727f271', component.options)
    } else {
      api.reload('1727f271', component.options)
    }
    module.hot.accept("./AdminQualityReport.vue?vue&type=template&id=1727f271", function () {
      api.rerender('1727f271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/AdminQualityReport.vue"
export default component.exports